import styled from "styled-components";

export const Wrapper = styled.div`
  .faq-question {
    font-size: 24px;
  }
`